// library imports         
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp, mergeTransactionData, deleteTransactionData } from "_core/slices/datas/TransactionSlice";

const AdminInquirySettingUpdateApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/inquiry_setting_update";

    const ExecAdminInquirySettingUpdateApi = async (requestParams, requestBinaryParams = {}) => {
        let response = null;
        let error = null;

        try {
            response = await ApiRequest({ url, requestParams, requestBinaryParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
            // 要約フォーマットをアップロードした場合は新規アセットが返ってくるので Redux にマージ
            if (response['t_asset_list'] != null && response['t_asset_list'].length > 0) {
                dispatch(mergeTransactionData({
                    tAssetList: response['t_asset_list'],
                }));
            }
            // 上書き保存で status=0 にした旧アセットは Redux からも除去
            if (response['deleted_t_asset_id'] && response['deleted_t_asset_id'] > 0) {
                dispatch(deleteTransactionData({
                    tAssetList: [response['deleted_t_asset_id']],
                }));
            }
        }
        return { response, error };
    };

    return ExecAdminInquirySettingUpdateApi;
};

export default AdminInquirySettingUpdateApi;
